// Payload types for the three live-transcription-indicator names declared in
// `../contributions/analytics.ts`: `active_session_indicator_clicked`,
// `active_session_control_clicked` and `active_session_navigation`. Extracted
// from `src/models/analytics/features/sessions.ts` (a partial extraction, so no
// rename to follow — history: `git log --follow` that file).

export enum IndicatorDisplayMode {
  Expanded = 'expanded',
  Collapsed = 'collapsed',
}

export enum ActiveSessionControlAction {
  Pause = 'pause',
  Resume = 'resume',
  Stop = 'stop',
}

export type ActiveSessionIndicatorClickedEventProps = {
  session_id: string;
  display_mode: IndicatorDisplayMode;
  current_page: string;
};

export type ActiveSessionControlClickedEventProps = {
  session_id: string;
  action: ActiveSessionControlAction;
  display_mode: IndicatorDisplayMode;
  current_page: string;
};

export type ActiveSessionNavigationEventProps = {
  session_id: string;
  from_path: string;
  to_path: string;
  was_blocked: boolean;
};
